import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { SimpleImage, Typography } from "@parkschannel/ui";
import { CTAList } from "../CTAList";
import { useAuth } from "../../Auth/AuthContext";
import { signIn } from "next-auth/react";
const CTA_DATA = [
    {
        id: 1,
        title: "Watch and create",
        text: "We curate videos that entertain and inform. Join our growing community of creators – or simply explore.",
        linkText: "Explore videos",
        linkHref: "/explore-parks",
        img: "/media/illustrations/watch-and-create.webp"
    },
    {
        id: 2,
        title: "Plan",
        text: "Our curated checklists will help make sure you have everything you need.",
        linkText: "Start planning",
        linkHref: "/trip-planner",
        img: "/media/illustrations/plan.webp"
    }
];
const WITHOUT_SESSION_CARD = {
    id: 3,
    title: "Go",
    text: "Create your own profile, playlists and checklists.",
    onClick: ()=>signIn("cognito"),
    buttonText: "Create an account",
    img: "/media/illustrations/join.webp"
};
const WITH_SESSION_CARD = {
    id: 4,
    title: "Go",
    text: "Create your own profile, playlists and checklists.",
    linkText: "Create an account",
    linkHref: "/users/me/",
    img: "/media/illustrations/join.webp"
};
export const CTASection = ()=>{
    const { useSession  } = useAuth();
    const session = useSession();
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full pl-4 py-10 max-w-screen-2xl mx-auto md:py-[56px] md:pl-[30px] lg:px-10 lg:py-[80px]",
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full max-w-6xl mx-auto",
            children: /*#__PURE__*/ _jsxs("section", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h2",
                        className: "pr-4 text-neutral-900 mb-6 md:pr-[30px] lg:pr-0 lg:mb-[56px]",
                        children: "Parks Channel - the first stop for your next adventure!"
                    }),
                    /*#__PURE__*/ _jsx(CTAList, {
                        data: [
                            ...CTA_DATA,
                            session && session.data ? WITH_SESSION_CARD : WITHOUT_SESSION_CARD
                        ],
                        renderImage: (data)=>/*#__PURE__*/ _jsx(SimpleImage, {
                                src: data.img,
                                className: "object-contain object-left",
                                alt: data.title,
                                fill: true
                            })
                    })
                ]
            })
        })
    });
};
